<script setup>
defineProps(['id', 'label', 'options'])

const model = defineModel();
</script>

<template>
    <div class="field field--color-picker">
        <fieldset class="colors">
            <legend v-html="label"></legend>
            
            <template v-for="option in options">
                <input type="radio" :name="`attribute-${id}`" :value="option" :id="`attribute-${id}-${option.id}`" v-model="model" required>
                
                <label :for="`attribute-${id}-${option.id}`">
                    <span class="color-box" :style="`background: ${option.colour};`"></span>
                    <span class="color-label" v-html="option.label"></span>
                </label>
            </template>
        </fieldset>
    </div>
</template>
